
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetoaurangabadbus() {



    const cardData =
    {
        keyword: 'Pune to Aurangabad Bus Hire On Rent',
        heading: 'Amruta Travels: Pune to Aurangabad Bus Hire On Rent',
        headingDescription: 'Amruta Travels offers Pune to Aurangabad Bus Hire On Rent, providing a dependable and comfortable solution for group travel to the historic city of Aurangabad. Whether you are planning a heritage tour to Ajanta and Ellora Caves, a family vacation, or a corporate trip, our well-maintained buses make your journey pleasant and worry-free. Select from our fleet of 17-seater, 32-seater, and 50-seater buses to fit your group’s needs. With experienced drivers, on-time departures, affordable pricing, and 24/7 support, Amruta Travels ensures your Pune to Aurangabad travel experience is smooth, safe, and memorable. Book now for a hassle-free trip!',


        top: 'Top Places to Visit in Aurangabad with Amruta Travels',
"topPlaces": [
  {
    "title": "Shri Vitthal Rukmini Mandir",
    "description": "The heart of Pandharpur, this temple is dedicated to Lord Vitthal (a form of Lord Krishna) and his consort Rukmini. It's a major pilgrimage site, especially during the Ashadhi and Kartiki Ekadashi festivals, attracting millions of devotees."
  },
  {
    "title": "Pundalik Temple",
    "description": "Dedicated to Bhakta Pundalik, whose devotion brought Lord Vitthal to Pandharpur. Located on the banks of the Chandrabhaga River, it's believed to be the place where Lord Vitthal stood on a brick, waiting for Pundalik."
  },
  {
    "title": "ISKCON Pandharpur",
    "description": "A serene temple complex established by the International Society for Krishna Consciousness. It offers a peaceful environment for meditation and spiritual learning, with regular kirtans and discourses."
  },
  {
    "title": "Kaikadi Maharaj Math",
    "description": "A unique spiritual center showcasing scenes from Hindu epics through life-size sculptures. It's both educational and devotional, attracting visitors interested in mythology and spirituality."
  },
  {
    "title": "Shri Gopalkrishna Temple",
    "description": "Situated atop Govardhan Hill, this temple resembles a fort and is dedicated to Lord Krishna. It's believed that the temple's kitchen and grinding stone were used by Lord Krishna himself."
  },
  {
    "title": "Vishnupad Temple",
    "description": "An open-hall temple supported by sixteen intricately carved pillars. It houses the sacred footprints of Lord Vishnu, making it a significant spot for devotees."
  },
  {
    "title": "Shri Sant Muktabai Math",
    "description": "Dedicated to the revered saint Muktabai, this math serves as a spiritual retreat. Devotees visit to pay homage and engage in devotional activities."
  },
  {
    "title": "Chandrabhaga River Ghats",
    "description": "The ghats along the Chandrabhaga River are considered sacred. Pilgrims take ritual baths here, especially during festivals, believing it purifies the soul."
  },
  {
    "title": "Bhima River",
    "description": "Also known as Chandrabhaga, the river holds religious significance. Its crescent shape near Pandharpur gives it the name 'Chandrabhaga', and it's integral to various rituals."
  },
  {
    "title": "Tukaram Mandir",
    "description": "A temple dedicated to Sant Tukaram, a prominent Varkari saint. It's a place of devotion and hosts regular bhajans and spiritual gatherings."
  }
],



 "services": [
    {
      "name": "Hire Pune to Aurangabad Mini Bus & Tempo Traveller",
      "description": "Amruta Travels offers comfortable mini buses and tempo travellers on rent for journeys from Pune to Aurangabad. Ideal for group tours, pilgrimages, or business travel, our AC and Non-AC options come with experienced drivers, ample luggage space, and smooth booking services for a hassle-free ride to the historic city."
    },
    {
      "name": "Pune to Aurangabad MIDC Bus on Rent",
      "description": "Book reliable buses for corporate and industrial travel to Aurangabad MIDC from Pune with Amruta Travels. Our services are ideal for factory visits, team transport, and industrial delegations, ensuring punctuality, safety, and comfort for every business need."
    },
    {
      "name": "Pune to Sambhaji Nagar Bus Hire",
      "description": "Plan your group travel from Pune to Sambhaji Nagar (Aurangabad) with our spacious and affordable bus rental services. Whether for tourism, events, or religious visits, Amruta Travels provides a well-maintained fleet with flexible seating capacities and professional drivers."
    },
    {
      "name": "Hire Pune to Ajanta Ellora Mini Bus",
      "description": "Explore the UNESCO World Heritage Sites of Ajanta and Ellora Caves from Pune with Amruta Travels’ mini bus rentals. Perfect for history enthusiasts, student groups, or family outings, these trips offer a comfortable and enriching travel experience to the ancient cave temples of Maharashtra."
    },
    {
      "name": "Tempo Traveller on Rent in Pune for Aurangabad Darshan",
      "description": "Amruta Travels provides Tempo Travellers from Pune for a scenic and spiritual Aurangabad Darshan. Our vehicles come with AC, push-back seats, and ample space, perfect for families or small groups looking to visit Grishneshwar, Bibi Ka Maqbara, Panchakki, and other landmarks."
    },
    {
      "name": "Pune to Aurangabad Darshan Bus on Rent",
      "description": "Book a full bus for a day or multi-day Aurangabad Darshan from Pune. Our AC buses are ideal for large groups visiting spiritual and historical sites such as Daulatabad Fort, Bibi Ka Maqbara, and Ellora. Enjoy peace of mind with timely service and expert drivers."
    },
    {
      "name": "Pune to Paithan Bus on Rent",
      "description": "Visit the revered Paithan town from Pune with Amruta Travels’ bus rental service. Known for its spiritual importance and the Jayakwadi Dam, Paithan is a popular destination for pilgrimages and family trips. Our fleet offers comfortable travel with AC options and skilled chauffeurs."
    },
    {
      "name": "Pune to Sambhaji Nagar Tempo Traveller on Rent",
      "description": "For small to medium-sized groups traveling from Pune to Sambhaji Nagar (Aurangabad), Amruta Travels provides AC tempo travellers with luxurious seating and safety features. Ideal for sightseeing, corporate tours, or personal visits to the Marathwada region."
    }
  ],
  "tableData": [
    ["Hire Pune to Aurangabad Mini Bus & Tempo Traveller", "Pune to Aurangabad MIDC Bus on Rent"],
    ["Pune to Sambhaji Nagar Bus Hire", "Hire Pune to Ajanta Ellora Mini Bus"],
    ["Tempo Traveller on Rent in Pune for Aurangabad Darshan", "Pune to Aurangabad Darshan Bus on Rent"],
    ["Pune to Paithan Bus on Rent", "Pune to Sambhaji Nagar Tempo Traveller on Rent"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Relaxing Travel to Aurangabad",
    "WhyChoosedescription": "Amruta Travels offers Pune to Aurangabad Bus Hire On Rent, ensuring a smooth, comfortable, and enjoyable journey. Whether you are visiting the historical Ajanta and Ellora Caves, the famous Bibi Ka Maqbara, or for any other purpose, our buses provide ample space, air conditioning, and modern amenities for a relaxing trip. You can sit back, relax, and enjoy the scenic journey as we take you to one of Maharashtra’s cultural gems."
  },
  {
    "WhyChooseheading": "Perfect for Group Sightseeing, Pilgrimages, and Corporate Travel",
    "WhyChoosedescription": "Our Pune to Aurangabad Bus Hire service is ideal for groups traveling for sightseeing, pilgrimages, or business purposes. Whether you're planning a group tour of the Ajanta and Ellora caves, a religious trip to the Grishneshwar Temple, or a corporate outing, we have buses that cater to all group sizes. We offer spacious seating, luggage space, and well-maintained buses to ensure a hassle-free journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers for Safe Travel",
    "WhyChoosedescription": "Safety is always our priority. Our experienced and professional drivers are skilled in handling long-distance journeys and are familiar with the best routes from Pune to Aurangabad. They are punctual, courteous, and follow all safety protocols to ensure a secure and timely journey. With a strong focus on passenger comfort and safety, our drivers ensure that your trip is as pleasant as possible."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing for All Your Travel Needs",
    "WhyChoosedescription": "We provide affordable pricing for Pune to Aurangabad Bus Hire On Rent. Our pricing is transparent, with no hidden charges, so you can plan your trip with confidence. Whether you need a bus for a day or a few days, we offer competitive rates to suit your budget. We believe in offering the best value for your money without compromising on comfort or service."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses for Maximum Comfort",
    "WhyChoosedescription": "We take great pride in maintaining our fleet of buses. Each vehicle is regularly serviced, cleaned, and sanitized to ensure it meets high standards of hygiene and comfort. Our buses feature spacious, air-conditioned seating, providing a smooth and comfortable journey. You can enjoy the entire trip with peace of mind, knowing that our vehicles are regularly inspected for safety and cleanliness."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations Across Pune and Aurangabad",
    "WhyChoosedescription": "Our Pune to Aurangabad Bus Hire service offers flexible pickup and drop-off locations, ensuring convenience for you and your group. Whether you're located at your office, home, or hotel in Pune, we can arrange a pickup from the most convenient location. Upon reaching Aurangabad, we will ensure that the drop-off is arranged at a suitable location, such as your hotel or any other place of your choice."
  },
  {
    "WhyChooseheading": "Customizable Itineraries Tailored to Your Group's Needs",
    "WhyChoosedescription": "Every group has unique needs, and we offer fully customizable itineraries to ensure your trip is perfect. Whether you want to visit multiple sites in Aurangabad, plan your stops along the way, or adjust the duration of the trip, we can tailor the journey to meet your requirements. Our team works with you to create an itinerary that enhances your travel experience."
  },
  {
    "WhyChooseheading": "Easy Booking Process and Dedicated Customer Support",
    "WhyChoosedescription": "Booking your Pune to Aurangabad Bus Hire with Amruta Travels is quick and hassle-free. You can book online, call our customer service team, or visit our office for assistance. Our dedicated customer support staff is available to help you with all aspects of your booking, from selecting the best bus to finalizing your travel itinerary. We ensure a seamless booking process and excellent customer service throughout your journey."
  }
]




























    }

const faqData = [
  {
    question: 'How can I hire a bus for a trip from Pune to Aurangabad?',
    answer: 'Hiring a bus for your Pune to Aurangabad trip with Amruta Travels is simple. You can book online, call our support team, or visit our office. We’ll help you select the right bus based on your group size and travel preferences.',
  },
  {
    question: 'What types of buses are available for the Pune to Aurangabad trip?',
    answer: 'We offer a wide range of buses for the Pune to Aurangabad journey, including 32, 35, 45, and 50-seater options. Whether you need a standard or luxury bus, we have a vehicle that suits your travel needs.',
  },
  {
    question: 'How long does it take to travel from Pune to Aurangabad?',
    answer: 'The travel time from Pune to Aurangabad is approximately 5 to 6 hours, depending on traffic conditions. Our experienced drivers ensure a smooth and safe journey, allowing you to enjoy the scenic ride.',
  },
  {
    question: 'Are the buses comfortable for the Pune to Aurangabad journey?',
    answer: 'Yes, all our buses are well-maintained and equipped with comfortable seating, air conditioning, and spacious interiors. Whether you’re traveling for leisure or business, we ensure a pleasant and comfortable experience.',
  },
  {
    question: 'Can I book a bus for a one-day trip to Aurangabad?',
    answer: 'Yes, we offer flexible booking options for one-day trips to Aurangabad. We’ll help customize your itinerary to visit top attractions like the Ellora Caves, Ajanta Caves, and Bibi Ka Maqbara.',
  },
  {
    question: 'Do you provide both standard and luxury buses for the Pune to Aurangabad trip?',
    answer: 'Yes, we provide both standard and luxury buses. Our luxury buses come with additional amenities such as premium seating, air conditioning, and entertainment options, making your journey even more comfortable and enjoyable.',
  },
  {
    question: 'How much does it cost to hire a bus for Pune to Aurangabad?',
    answer: 'The cost of hiring a bus depends on the size of the bus, the duration of the trip, and the services you require. Contact us with your trip details, and we’ll provide a customized and transparent quote.',
  },
  {
    question: 'Can I request specific pickup and drop-off locations for the trip?',
    answer: 'Yes, we offer flexible pickup and drop-off locations. You can share your preferred locations in Pune and Aurangabad, and we’ll tailor the route according to your convenience.',
  },
  {
    question: 'Why should I choose Amruta Travels for Pune to Aurangabad bus hire?',
    answer: 'Amruta Travels is known for providing reliable, comfortable, and safe bus rental services for trips from Pune to Aurangabad. Our well-maintained buses, experienced drivers, and customer-first approach ensure a smooth and enjoyable trip.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rajesh Deshmukh',
    role: 'Business Executive, Pune',
    text: 'We rented a 45-seater bus from Amruta Travels for a business trip to Aurangabad. The bus was clean, comfortable, and on time. The driver was professional and made our journey smooth. Highly recommend their services for long trips!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sunita Yadav',
    role: 'Group Leader, Pune',
    text: 'I booked a 35-seater bus for a family trip to Aurangabad. The bus was very comfortable, and the driver ensured we had a safe and enjoyable journey. We had a great time visiting the Ellora Caves. I highly recommend Amruta Travels for group trips!',
    rating: 5,
  },
];

















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Aurangabad Bus Hire On Rent",
  "image": "https://bushireinpune.com/assets/images/pune-to-aurangabad-bus-hire.jpg",
  "description": "Hire buses from Pune to Aurangabad including Mini Bus, Tempo Traveller, and Urbania for sightseeing and industrial visits. Services available for Ajanta Ellora, Paithan, MIDC, and Aurangabad Darshan. Affordable, comfortable group transport from Amruta Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5442"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4899",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-aurangabad-bus-hire"
  }
};





    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Pune to Aurangabad Bus Hire | Ajanta Ellora, Paithan & MIDC Trips | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent Mini Buses and Tempo Travellers from Pune to Aurangabad. Visit Ajanta Ellora, MIDC, Paithan and more. Book affordable bus hire for Aurangabad darshan and tours with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/34.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetoaurangabadbus;